module.exports = {
  siteName : `PhilPsyCor Online Test`,

  portFe : `8080`,
  portBe : `8081`,

  backendHost: `http://3.1.120.29:8081/api`
}
